import { getEditorialCapabilities, isEditorialResource } from 'app/models/editorialCapabilities';
import { USER_ROLES } from 'app/models/user/user.constants';
import { loadEditorialAccessMe } from 'app/services/editorialAccess.service';
import { canOpenEditorialContent, canOpenEditorialProgram } from 'app/services/editorialPrograms.service';

export const EDITORIAL_MUTATION_CANCELLED = Object.freeze({ cancelled: true, error: null });

// Un lote autorizado una sola vez se cancela por dos vías: la autorización previa
// (el runner devuelve el objeto cancelado) o cualquiera de sus peticiones.
export function isCancelledEditorialBatch(result) {
  if (result?.cancelled) return true;
  return Array.isArray(result) && result.some((response) => response?.cancelled);
}

export async function authorizeEditorialMutation(access, resources, signal, onAccess) {
  if (signal?.aborted || !getEditorialCapabilities(access, resources).canWrite) return false;
  // La revalidación contra /me solo aporta algo a quien puede estar restringido.
  if (access.role !== USER_ROLES.publisher) return true;
  const data = await loadEditorialAccessMe(signal);
  if (!data || signal?.aborted) return false;
  onAccess?.(data);
  const current = { ...access, data };
  if (!getEditorialCapabilities(current, resources).canWrite) return false;
  if (access.role === USER_ROLES.publisher && data.restricted) {
    if (!resources.length || resources.some((resource) => !isEditorialResource(resource))) return false;
    const allowed = await Promise.all(
      resources.map((resource) => (resource.type === 'program' ? canOpenEditorialProgram : canOpenEditorialContent)(resource.guid, signal))
    );
    if (allowed.some((value) => value !== true)) return false;
  }
  return !signal?.aborted;
}

function isCurrentMutation(getSnapshot, snapshot, signal) {
  const current = getSnapshot();
  return !signal?.aborted && current === snapshot && getEditorialCapabilities(current?.access, current?.resources).canWrite;
}

export async function runEditorialMutation({ getSnapshot, operation, signal, authorize = authorizeEditorialMutation, onAccess, onDenied }) {
  const snapshot = getSnapshot();
  if (signal?.aborted || !getEditorialCapabilities(snapshot?.access, snapshot?.resources).canWrite) return EDITORIAL_MUTATION_CANCELLED;
  try {
    if (!(await authorize(snapshot.access, snapshot.resources, signal, onAccess))) {
      if (!signal?.aborted) onDenied?.();
      return EDITORIAL_MUTATION_CANCELLED;
    }
  } catch {
    if (!signal?.aborted) onDenied?.();
    return EDITORIAL_MUTATION_CANCELLED;
  }
  if (!isCurrentMutation(getSnapshot, snapshot, signal)) return EDITORIAL_MUTATION_CANCELLED;
  const response = await operation();
  return isCurrentMutation(getSnapshot, snapshot, signal) ? response : EDITORIAL_MUTATION_CANCELLED;
}
